import React, { Component } from "react";
import {
  Col,
  Row,
  Container,
  Modal,
  Card,
  CardHeader,
  Table,
  Button
} from "reactstrap";
import DetailedOrderCard from "../../components/DetailedOrderCard";
import RequestManager from "../../singletons/RequestManager";
import moment from "moment";
import DatePicker from "react-datepicker";
import "react-datepicker/dist/react-datepicker.css";
import { CSVLink } from "react-csv";
import { SDK_CHROME } from "../../config/Constants";
import LoadingOverlay from "react-loading-overlay";
import config from "../../config";
import {generateHeaders, generateHeaderswithBasicAuthToken, generateEpochTimestamp, generateSignature} from '../../utils/helper';

export default class OrderHistory extends Component {
  constructor(props) {
    super(props);
    this.state = {
      orders: [],
      orderModalVisible: false,
      focusedDate: null,
      storeInformation: null,
      startDate: moment().endOf("day"),
      endDate: moment().endOf("day"),
      bookingStartDate: moment().endOf("day"),
      bookingEndDate: moment().endOf("day"),
      pageText: "Your past orders",
      printSdkType: "",
      bookingDateSelected: false,
      spinnerLoading: false,
      grandTotal : 0,
    };
  }

  componentWillMount() {
    this.checkLoginMode();
  }
  componentDidMount() {
    document
      .getElementsByTagName("input")[0]
      .setAttribute("readonly", "readonly");
    document
      .getElementsByTagName("input")[0]
      .setAttribute("readonly", "readonly");
    this.getOrders();
  }

  checkLoginMode = () => {
    let storeInformation = JSON.parse(localStorage.getItem("storeInformation"));
    let loginMode = localStorage.getItem("loginMode");
    if (loginMode === "merchant") {
      this.setState({
        storeInformation: storeInformation,
        pageText: "Your Order Summary"
      });
    } else {
      this.setState({ storeInformation: storeInformation });
    }
  };
 
  toggleModal = () => {
    this.setState({
      orderModalVisible: !this.state.orderModalVisible
    });
  };
  handleStartDateChange = date => {
    this.setState({
      startDate: date
    });
    console.log("startDate", this.state.startDate);
  };
  handleBookingStartDateChange = date => {
    this.setState({
      bookingStartDate: date
    });
    console.log("startDate", this.state.startDate);
  };
  handleBookingEndDateChange = date => {
    if (
      Date.parse(this.state.bookingStartDate.format("MM/DD/YYYY")) >=
      Date.parse(date.format("MM/DD/YYYY"))
    ) {
      if (
        Date.parse(this.state.bookingStartDate.format("MM/DD/YYYY")) ===
        Date.parse(date.format("MM/DD/YYYY"))
      ) {
        this.setState({
          bookingEndDate: date
        });

        console.log("endDate 1" + date.format("MM/DD/YYYY"));
      } else {
        alert("End date should be greater than Start date");
      }
    } else {
      console.log("bookingEndDate 2" + date);
      this.setState({
        bookingEndDate: date
      });
    }
  };
  handleEndDateChange = date => {
    if (
      Date.parse(this.state.startDate.format("MM/DD/YYYY")) >=
      Date.parse(date.format("MM/DD/YYYY"))
    ) {
      if (
        Date.parse(this.state.startDate.format("MM/DD/YYYY")) ===
        Date.parse(date.format("MM/DD/YYYY"))
      ) {
        this.setState({
          endDate: date
        });

        console.log("endDate 1" + date.format("MM/DD/YYYY"));
      } else {
        alert("End date should be greater than Start date");
      }
    } else {
      console.log("endDate 2" + date);
      this.setState({
        endDate: date
      });
    }
  };

  getOrders = async () => {
    //this.setState({ spinnerLoading: true });
    let requestManager = new RequestManager();
    let storeInformation = JSON.parse(localStorage.getItem("storeInformation"));

    let loginMode = localStorage.getItem("loginMode");
    let params = {};
    if (loginMode === "store") {
      params = {
        storeId: storeInformation.store.id
      };
    } else if (loginMode === "merchant") {
      params = {
        merchantId: storeInformation.merchant.id
      };
    }

    let date = "";
    let startdate = "";
    let enddate = "";

    if (this.state.startDate !== null) {
      date = this.state.startDate.format("YYYY-MM-DDT");
      date = date + "00:00:00+05:30";
      params.createdAt_Gte = date;
      startdate = date;
    }
    if (this.state.endDate !== null) {
      params.createdAt_Lte = this.state.endDate.format();
      enddate = this.state.endDate.format();
    }
    console.log("params", params);
    let response = {};
    //  response = await requestManager.getResponseFromPredefinedQuery(
    //   "getOrderHistory",
    //   params
    // );
  
    
    let authToken = storeInformation.token   
    var vtimestamp = generateEpochTimestamp();
    
     response = await fetch(config.getHost() + "/order/getstorepastorders/", {
        method: "POST",
        headers: {
            Authorization: `Token ${authToken}`,
            'Content-Type': 'application/json',
            Timestamp: vtimestamp,
            Signature: generateSignature(vtimestamp, authToken)
          },
        body: JSON.stringify({
          store_id: storeInformation.store.id,
          graphql:true,
          startdate: startdate,
          enddate : enddate
        }),    
    });
    let jsonres = {};
    if (response.status === 200){
      let jsonres = await response.json();
     // console.log('pastorders', jsonres)
    //&& jsonres.edges.length > 0
    if (jsonres && jsonres !== null ) {
     
      let grandTotal = 0.0;
      for (let i = 0; i < jsonres.data.orderHistory.edges.length; i++) {
        if (jsonres.data.orderHistory.edges[i].node.status === "DELIVERED"){
        grandTotal =
          grandTotal +
          jsonres.data.orderHistory.edges[i].node.cart.settlementPrice;
}
      }

      this.setState({
        spinnerLoading: false,
        orders: jsonres.data.orderHistory.edges,
        grandTotal: grandTotal.toFixed(2)
      });
    }} else {
      this.setState({ spinnerLoading: false });
    }

    console.log(response);
  };

  getCountOfItems = () => {
    if (this.state.selectedOrder) {
      let cartItems = this.state.selectedOrder.node.cart.cartItems.edges;
      let quantity = 0;
      cartItems.forEach(cartItem => {
        quantity = quantity + cartItem.node.quantity;
      });

      return quantity;
    }
  };

    // fetchOrderDetails = async (orderID) => {
    //   let storeInformation = JSON.parse(localStorage.getItem("storeInformation"));
  
    //   let requestManager = new RequestManager();
  
    //   let params = {
    //     orderId: orderID,
    //   };
    //   console.log('params fetchOrderDetails', params);
    //   let response = await requestManager.getResponseFromPredefinedQuery(
    //     "getOrderDetails",
    //     params
    //   );
  
    //   if (response.error === null) {
    //     let orderDetails = response.data.orderDetails.edges[0];
    //     this.setState({ selectedOrder: orderDetails });
    //     this.toggleModal();
    //   } else {
    //     alert("Something went wrong try again.");
    //     console.log("Connection to server failed.");
    //   }
    // };
   fetchOrderDetails = async (orderID) => {
    
      this.setState({ spinnerLoading: true });
 
        let storeInformation = JSON.parse(localStorage.getItem('storeInformation'));
          let authToken = storeInformation.token   
          var vtimestamp = generateEpochTimestamp();
          
        let   response = await fetch(config.getHost() + "/order/getorderdetails/", {
              method: "POST",
              headers: {
                  Authorization: `Token ${authToken}`,
                  'Content-Type': 'application/json',
                  Timestamp: vtimestamp,
                  Signature: generateSignature(vtimestamp, authToken)
                },
              body: JSON.stringify({
                 order_id: orderID,
              }),    
          });
          let jsonres = {};
          if (response.status === 200){
            let jsonres = await response.json();

          if (jsonres && jsonres !== null ) {

      //if (response.error === null) {
        let orderDetails = jsonres.data.orderDetails.edges[0];
         // let orderDetails = response.data.orderDetails.edges[0];
         this.setState({ selectedOrder: orderDetails });
          this.setState({ spinnerLoading: false });
        this.toggleModal();
      } else {
         this.setState({ spinnerLoading: false });
        alert("Something went wrong try again.");
        console.log("Connection to server failed.");
      }
       
    }
  };

  getCSVData = () => {
    let startdate = "",
      enddate = "";

    if (this.state.bookingDateSelected === false) {
      startdate = this.state.startDate.format("YYYY-MM-DD");
      enddate = this.state.endDate.format("YYYY-MM-DD");
    } else {
      startdate = this.state.bookingStartDate.format("YYYY-MM-DD");
      enddate = this.state.bookingEndDate.format("YYYY-MM-DD");
    }

    let csvData = [
      [this.state.pageText],
      ["Fullfilled Grand Total", "Start Date", "End Date"],
      [this.state.grandTotal, startdate, enddate],
      [""],
      [""],
      ["Order Id", "Token", "Status", "Date/Time", "Amount", "Store", "OrderMode", "Priority", "DeliveryTime","Expected DeliveryTime" ]
    ];
    // eslint-disable-next-line
    this.state.orders.map(order => {
      csvData.push([
        order.node.orderId,
        order.node.storeToken,
        order.node.status,
        moment(order.node.createdAt).format("MMMM Do YYYY, h:mm a"),
        order.node.cart.settlementPrice,
        order.node.cart.pickupPoint.store.name,
        order.node.cart.checkout.mode,
        order.node.priority,
        order.node.deliveredTime,
        order.node.expectedDeliveryTime
      ]);
    });
    // eslint-disable-next-line
    return csvData;
  };

  render() {
    const { spinnerLoading } = this.state;
    return (
      <LoadingOverlay
        style={{ width: "100%", height: "100%", zIndex: 999 }}
        active={spinnerLoading === true ? true : false}
        spinner
        text="Loading ..."
      >
        <Container fluid style={{ padding: 0, margin: 0 }}>
          <Modal
            isOpen={this.state.orderModalVisible}
            toggle={this.toggleModal}
            size="lg"
          >
            <DetailedOrderCard
              editable={false}
              order={this.state.selectedOrder}
              toltalItemCount={null}
              goBack={this.toggleModal}
              refreshOrders={() => {}}
              pastOrder={true}
              storeInformation={this.state.storeInformation}
            />
          </Modal>

          <Row noGutters>
            <Col>
              <Card>
                <CardHeader>
                  <Container fluid>
                    <Row>
                      <Col
                        xs="12"
                        sm="12"
                        md="4"
                        lg="4"
                        style={{ display: "flex", alignItems: "center" }}
                      >
                        <h5>{this.state.pageText}</h5>
                      </Col>
                      <Col
                        xs="12"
                        sm="12"
                        md="4"
                        lg="4"
                        style={{ display: "flex", alignItems: "center" }}
                      >
                        <h5>{"Fullfilled Grand Total= " + this.state.grandTotal}</h5>
                      </Col>
                      
                      <Col
                        xs="12"
                        sm="12"
                        md="4"
                        lg="4"
                        style={{ display: "flex", alignItems: "center" }}
                      >
                        <h5 style={{ marginRight: "10px" }}>
                        {"Total Orders: " + this.state.orders.length}</h5>
                        </Col>  
                    </Row>
                    <Row>
                      <div
                        style={{
                          justifyContent: "space-between"
                        }}
                      >
                        <p> Calender Date</p>
                          <DatePicker
                            selected={this.state.startDate}
                            maxDate={moment().endOf("day")}
                            dateFormat="DD/MM/YYYY"
                            id="input"
                            readonly
                            onChange={this.handleStartDateChange}
                          />
                        <div style={{ marginTop: 15, marginBottom: 15 }}>
                          <DatePicker
                            selected={this.state.endDate}
                            dateFormat="DD/MM/YYYY"
                            id="input"
                            disabledKeyboardNavigation={true}
                            maxDate={moment().endOf("day")}
                            onChange={this.handleEndDateChange}
                          />
                        </div>
                        <Button
                          style={{ marginLeft: 20 }}
                          onClick={() => {
                            // this.setState({"bookingDateSelected": false})
                            this.getOrders();
                          }}
                        >
                          Submit
                        </Button>
                        {
                          // <h1> Booking Date</h1>
                          // <DatePicker
                          // selected={this.state.bookingStartDate}
                          // maxDate={moment().endOf("day")}
                          // dateFormat="DD/MM/YYYY"
                          // id ="input"
                          // readonly
                          // onChange={this.handleBookingStartDateChange}
                          // />
                          // <div style = {{marginTop:15,marginBottom:15}}>
                          //   <DatePicker
                          //     selected={this.state.bookingEndDate}
                          //     dateFormat="DD/MM/YYYY"
                          //     id="input"
                          //     disabledKeyboardNavigation ={true}
                          //     maxDate={moment().endOf("day")}
                          //     onChange={this.handleBookingEndDateChange}
                          //   />
                          // </div>
                          // <Button style={{marginLeft:20}} onClick = {
                          //   ()=>{
                          //     this.setState({"bookingDateSelected": true})
                          //     this.getOrders
                          //   }
                          // }>Submit Booking Date</Button>
                        }
                        {/* {this.state.storeInformation.store.printSdkType ===
                        SDK_CHROME ? ( */}
                          <CSVLink
                            className="btn btn-primary"
                            style={{ marginLeft: 20 }}
                            filename={"OrderSummary.csv"}
                            data={this.getCSVData()}
                          >
                            Export to CSV
                          </CSVLink>
                        {/* ) : null} */}
                      </div>
                    </Row>
                  </Container>
                </CardHeader>
                <Table responsive>
                  <tbody>
                    <tr>
                      <th>Order Id</th>
                      <th>Token</th>
                      <th>Status</th>
                      <th>Date/Time</th>
                      <th>Amount</th>
                      <th>Store</th>
                      <th>OrderMode</th>
                      <th>Priority</th>
                      <th>Delivered Time</th>
                      <th>Expected Delivery Time</th>
                    </tr>
                    {this.state.orders.map(order => {
                      return (
                        <tr
                          key={order.node.id}
                          onClick={() => {
                            this.fetchOrderDetails(order.node.orderId);
                            
                            
                          }}
                        >
                          <td>{order.node.orderId}</td>
                          <td>{order.node.storeToken}</td>
                          <td>{order.node.status}</td>
                          <td>
                            {moment(order.node.createdAt).format(
                              "MMMM Do YYYY, h:mm a"
                            )}
                          </td>
                          <td>{"₹" + order.node.cart.settlementPrice}</td>
                          <td>{order.node.cart.pickupPoint.store.name}</td>
                          <td>{order.node.cart.checkout.mode}</td>
                          <td>{order.node.priority}</td>
                           <td>
                            {order.node.deliveredTime !== null ? (
                            moment(order.node.deliveredTime).format(
                              "MMMM Do YYYY, h:mm a"
                            )):null}
                          </td>
                          
                           <td>
                            {order.node.expectedDeliveryTime !== null ? (
                            moment(order.node.expectedDeliveryTime).format(
                              "MMMM Do YYYY, h:mm a"
                            )):null}
                          </td>
                          
                        </tr>
                      );
                    })}
                  </tbody>
                </Table>
              </Card>
            </Col>
          </Row>
        </Container>
      </LoadingOverlay>
    );
  }
}



// WEBPACK FOOTER //
// ./src/pages/OrderHistory/OrderHistory.js